import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormField } from '@shared/ui';
import { CategoriesPicker } from '../categories-picker';
import type { ProfileFormValues } from '../../model/schema';

export function CategoriesTab() {
  const { t } = useTranslation();
  const form = useFormContext<ProfileFormValues>();

  return (
    <div className="flex flex-col gap-6">
      <FormField
        label={t('profile.categories.label')}
        required
        hint={t('profile.categories.hint')}
        error={form.formState.errors.categories?.message}
      >
        {() => (
          <Controller
            control={form.control}
            name="categories"
            render={({ field }) => (
              <CategoriesPicker
                value={field.value}
                onChange={(ids, { selectedEco }) => {
                  field.onChange(ids);
                  form.setValue('ecoProducer', selectedEco, { shouldDirty: true });
                }}
              />
            )}
          />
        )}
      </FormField>
    </div>
  );
}
